import {combineReducers} from '@reduxjs/toolkit';
import menuReducer from './menuSlice';
import settingsReducer from './settingsSlice';
import userReducer from './userSlice';
import {api} from './api';

const rootReducer = combineReducers({
  [api.reducerPath]: api.reducer,
  menu: menuReducer,
  settings: settingsReducer,
  user: userReducer,
});

export default rootReducer;
